import { QuestionDisablePage } from './QuestionDisablePage';
export default QuestionDisablePage;